import { render, staticRenderFns } from "./PersonalDataTitle.vue?vue&type=template&id=1ea7fe25&"
import script from "./PersonalDataTitle.controller.js?vue&type=script&lang=js&"
export * from "./PersonalDataTitle.controller.js?vue&type=script&lang=js&"
import style0 from "./PersonalDataTitle.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports